import React, { createContext, useState, useContext, useEffect, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { lightNotionTheme, darkNotionTheme } from '../themes/notionTheme';

const ThemeContext = createContext();

// Usamos los temas predefinidos de notionTheme.js
const lightTheme = lightNotionTheme;
const darkTheme = darkNotionTheme;

export const ThemeProviderWrapper = ({ children }) => {
  const [themeMode, setThemeMode] = useState('light');

  useEffect(() => {
    const savedTheme = localStorage.getItem('themeMode');
    if (savedTheme) {
      setThemeMode(savedTheme);
    }
  }, []);

  const toggleTheme = () => {
    const newMode = themeMode === 'light' ? 'dark' : 'light';
    setThemeMode(newMode);
    localStorage.setItem('themeMode', newMode);
  };

  // Usar el tema de Notion según el modo
  const currentTheme = themeMode === 'light' ? lightTheme : darkTheme;

  // 7 sep 2026: mismo fix que LanguageContext/AuthContext -- value
  // memoizado para no re-renderizar a todos los consumidores en cada
  // render del provider. Solo cambia cuando cambia el modo.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const value = useMemo(() => ({ themeMode, toggleTheme }), [themeMode]);

  return (
    <ThemeContext.Provider value={value}>
      <MuiThemeProvider theme={currentTheme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext;
